import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { BehaviorSubject, Observable } from 'rxjs';
//import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import axios from "axios";
import { Router, ActivatedRoute } from '@angular/router';
//import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    private defaultUrl: any;
    // private currentUserSubject: BehaviorSubject<User>;
    // public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        // this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
        // this.currentUser = this.currentUserSubject.asObservable();
        this.defaultUrl = axios.create({
            baseURL: environment.API
        });
    }

}